import type { GalleryImage } from '../../types/gallery';

/** The date a gallery photo stands for: when it was taken, else when it was uploaded (ISO). */
export function galleryImageDate(image: GalleryImage): string {
  return image.photoTakenAt ?? image.uploadedAt;
}

/** Short localised date for tiles and the filmstrip, e.g. "10. Okt. 2026". */
export function formatGalleryDate(iso: string, language?: string): string {
  return new Date(iso).toLocaleDateString(language || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/** The note's first line, used as the tile caption; null without a note. */
export function galleryImageCaption(image: GalleryImage): string | null {
  const first = image.notes?.trim().split('\n')[0]?.trim();
  return first ? first : null;
}

/** Local calendar date (YYYY-MM-DD) of an ISO timestamp, for a date input. */
export function toLocalDateInputValue(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
